const MessageAlert = (setMessage, config) => {
  setMessage(config)
  // console.log('DESDE UTILS/MESSAGEALERT: ', config)
  setTimeout(()=>{
    setMessage(null)
  },3000)
}

export default MessageAlert
